import {action, query} from "@solidjs/router";
import sdk from "~/sdk/sdk";
import {ApiError} from "~/sdk/error";
import {CreateMember, UpdateMember} from "@gs-yoga/sdk/types";

export const getMember = query(async () => {
    try {
        return await sdk().member.me().json()
    } catch (error: any) {
        const status = error.response?.status
        if (status === 401) {
            return null
        }
        throw new ApiError("Failed to get member", error)
    }
}, "member")

export const register = action(async (member: CreateMember) => {
    try {
        sdk().member.create(member)
    } catch (e) {
        throw new ApiError("Failed to create member", e)
    }
})

export const updateMember = action(async (id: string, req: UpdateMember) => {
    try {
        await sdk().member.update(id, req)
    } catch (e) {
        throw new ApiError("Failed to update member", e)
    }
})